/**
 * Config AdSense — mínima.
 *
 * O site NÃO tem mais unidades `<ins>` manuais. Quem decide onde o anúncio
 * aparece é o Auto Ads do Google (ligado no painel do AdSense por domínio) —
 * ele lê a página e escolhe os melhores lugares sozinho. Unidades fixas
 * quebravam o layout e por isso foram removidas em jul/2026.
 *
 * Única env: NEXT_PUBLIC_ADSENSE_PUBLISHER_ID=ca-pub-…
 */

function isPlaceholder(id: string | undefined | null): boolean {
  if (!id) return true
  const v = id.trim()
  if (!v) return true
  return /x{4,}/i.test(v) || v.includes('XXXXXXXX')
}

export const ADSENSE_PUBLISHER = process.env.NEXT_PUBLIC_ADSENSE_PUBLISHER_ID?.trim() || ''

export function hasAdSensePublisher(): boolean {
  return !isPlaceholder(ADSENSE_PUBLISHER)
}

/**
 * Rotas onde o Auto Ads NÃO deve rodar — o script nem carrega nelas.
 *
 * Não é para "controlar posição" (isso é do Google). É para manter anúncio fora
 * de onde ele só atrapalha ou fere política:
 *  - conversão/conta: premium, sign-*, onboarding, obrigado, checkout;
 *  - área logada com sidebar: dashboard, registrar, admin, painel… (mas essas já
 *    exigem login, e usuário logado não recebe anúncio — ver shouldShowAds);
 *  - conteúdo fino / gerado por usuário: /links, /c/[slug];
 *  - utilitárias: termos, privacidade, cookies, contato.
 *
 * Todo o RESTO (home, calculadoras, blog, glossário, profissões, templates,
 * comprovante, DRE, pró-labore) fica liberado pro Auto Ads escolher os espaços.
 */
export function isAdsPathBlocked(path: string | null): boolean {
  if (!path) return true
  return (
    path.startsWith('/links') ||
    path.startsWith('/c/') ||
    path.startsWith('/termos') ||
    path.startsWith('/privacidade') ||
    path.startsWith('/cookies') ||
    path.startsWith('/contato') ||
    path.startsWith('/painel') ||
    path.startsWith('/insights') ||
    path.startsWith('/dashboard') ||
    path.startsWith('/registrar') ||
    path.startsWith('/onboarding') ||
    path.startsWith('/admin') ||
    path.startsWith('/premium') ||
    path.startsWith('/obrigado') ||
    path.startsWith('/sign-') ||
    path.startsWith('/forgot-password') ||
    path.startsWith('/reset-password') ||
    path.startsWith('/offline') ||
    path.startsWith('/api')
  )
}
